"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _API2 = _interopRequireDefault(require("./API"));

var desktopUrl = 'websitegrader/v2/preview/desktop/';
var mobileUrl = 'websitegrader/v2/preview/mobile/';
var timeout = 30000;
var DESKTOP_SCREENSHOT_WIDTH = 1500;
var DESKTOP_SCREENSHOT_HEIGHT = 800;
var MOBILE_SCREENSHOT_WIDTH = 375;
var MOBILE_SCREENSHOT_HEIGHT = 667;

var _default =
/*#__PURE__*/
function (_API) {
  (0, _inherits2.default)(_default, _API);

  function _default() {
    (0, _classCallCheck2.default)(this, _default);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(_default).apply(this, arguments));
  }

  (0, _createClass2.default)(_default, [{
    key: "getDesktopPreview",
    value: function getDesktopPreview(websiteUrl) {
      return this.makeGetRequest(desktopUrl + websiteUrl, {
        timeout: timeout,
        query: {
          width: DESKTOP_SCREENSHOT_WIDTH,
          height: DESKTOP_SCREENSHOT_HEIGHT
        }
      });
    }
  }, {
    key: "getMobilePreview",
    value: function getMobilePreview(websiteUrl) {
      return this.makeGetRequest(mobileUrl + websiteUrl, {
        timeout: timeout,
        query: {
          width: MOBILE_SCREENSHOT_WIDTH,
          height: MOBILE_SCREENSHOT_HEIGHT
        }
      });
    }
  }]);
  return _default;
}(_API2.default);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/api/PreviewAPI.js
// module id = 314
// module chunks = 0